import { memo, useState } from 'react';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { User, GridDots } from 'tabler-icons-react';
import { currentUser } from 'Utils';
import { useDelayUnmount, useModal, useAuthModal } from 'Hooks';
import { Button, Dropdown, DropdownUser, DropdownService } from 'Elements';
import Logo from 'assets/img/icon-logo.svg';
import Placeholder from 'assets/img/img-user-default.png';
import styles from 'partials/main-header.module.scss';
import buttonStyles from 'partials/button.module.scss';

export const MainHeader = memo(({ className }) => {
	const [openModal, toggleModal] = useModal();
	const [modalName, setModalName] = useState('login');
	const DynamicModal = useAuthModal(modalName);
	const [openDropdown, setOpenDropdown] = useState({
		service: false,
		user: false
	});
	const shouldRenderDropdownService = useDelayUnmount(
		openDropdown.service,
		350
	);
	const shouldRenderDropdownUser = useDelayUnmount(openDropdown.user, 350);
	const isDesktop = useMediaQuery({ minWidth: 992 });
	const user = useSelector((state) => state.user);

	const handleDropdown = (selected) => {
		setOpenDropdown((prev) => ({
			...prev,
			[selected]: !openDropdown[selected]
		}));
	};

	const handleModalChange = (modal_name) => {
		setModalName(modal_name);
	};

	const handleCloseModal = () => {
		setModalName('login');
		toggleModal();
	};

	const headerClass = cx(className, styles.header, {
		[styles.mobileHeader]: !isDesktop
		// [styles.header]: isDesktop
	});

	return (
		<header className={headerClass}>
			<div className={styles.logo}>
				<Link to="/">
					<img src={Logo} alt="shahrstory" className="logo" />
				</Link>
			</div>
			<div className={styles.icons}>
				<div className={styles.dropdown}>
					<Button
						onClick={() => handleDropdown('service')}
						className={styles.icon}>
						<GridDots />
					</Button>
					{shouldRenderDropdownService && (
						<Dropdown
							isOpen={openDropdown.service}
							onClickOut={() => handleDropdown('service')}>
							<DropdownService />
						</Dropdown>
					)}
				</div>
				<div className={styles.dropdown}>
					{!currentUser.isLogin() && (
						<Button
							className={cx(styles.icon, buttonStyles.btn)}
							onClick={toggleModal}>
							<User />
						</Button>
					)}
					{currentUser.isLogin() && (
						<div
							role="button"
							tabIndex="0"
							className={cx(styles.icon, buttonStyles.btn)}
							onKeyDown={() => handleDropdown('user')}
							onClick={() => handleDropdown('user')}>
							<img
								src={
									currentUser.getUser()?.avatar ??
									user.info?.avatar ??
									Placeholder
								}
								alt={user.info?.name}
								className={styles.dropdownImage}
							/>
						</div>
					)}
					{shouldRenderDropdownUser && (
						<Dropdown
							isOpen={openDropdown.user}
							onClickOut={() => handleDropdown('user')}>
							<DropdownUser
								onClose={() => handleDropdown('user')}
							/>
						</Dropdown>
					)}
				</div>
				<DynamicModal
					size="sm"
					isOpen={openModal}
					onClose={handleCloseModal}
					onToggleLogin={() => handleModalChange('login')}
					onToggleForget={() => handleModalChange('forget')}
					onToggleRegister={() => handleModalChange('register')}
					onTogglePassword={() => handleModalChange('password')}
				/>
			</div>
		</header>
	);
});
